import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { DetectEnvironment } from "../../EnvironmentSettings";
import MainLogo from "../../views/pages/SignUpScreens/MainLogo";

interface SidebarHeaderProps {
    sidebarBgColor: string;
}

class SidebarHeader extends Component<SidebarHeaderProps, {}> {
    render() {
        return (
            <div className="sidebar-header">
                <div className="logo clearfix">
                    <NavLink to="/" className="logo-text">
                        <MainLogo/>
                        {/* <div className="login-logo-mobile">
                            <img src={process.env.PUBLIC_URL + "/image/logo-mobile.svg"} alt="logo"  />
                        </div> */}
                        {/* <img src={process.env.PUBLIC_URL + "/image/" +DetectEnvironment.config.REACT_APP_LOGO} alt="logo" /> */}
                        {/* <img src={process.env.PUBLIC_URL + "/logo/" + process.env.REACT_APP_LOGO} alt="logo" /> */}
                    </NavLink>
                </div>
            </div>
        );
    }
}

export default SidebarHeader;
